import { UserRoleDTO } from './userRoleDTO';

export class UserDTO{
    
    public id! : number;
        public firstName! :string;
        public lastName! : string;
        public email! : string;
        public phoneNumber? : string;
        public confirmedTermsAndConditions? : string;
        public role! : UserRoleDTO;
        public customerId?  : number;
        public customerName? : string;
        public vendorId? : number;
        public vendorName? : string;
        public lockoutEnabled? : boolean;
        public twoFactorEnabled? : boolean;
        public canBeDeleted? : boolean;
        public deleted? : boolean;
        public lastPasswordChange? : string;

}